import React from 'react';
import PropTypes from 'prop-types';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SovosProvider } from 's1-ui';
import BaseRoutes from './BaseRoutes';

// if (process.env.NODE_ENV !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

const Root = ({ store }) => (
  <SovosProvider>
    <Provider store={ store }>
      <HashRouter>
        <BaseRoutes />
      </HashRouter>
    </Provider>
  </SovosProvider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired
};

export default Root;
